import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { VendorOnboardingService } from '../services/vendor-onboarding.service';

const STEP_ROUTES = ['details', 'documents', 'review'] as const;

/**
 * Blocks deep-links to onboarding steps beyond what Continue has unlocked.
 * Redirects to the furthest unlocked step when the target is ahead.
 */
export const requireOnboardingStep: CanActivateFn = (route) => {
  const onboarding = inject(VendorOnboardingService);
  const router = inject(Router);

  const path = route.routeConfig?.path ?? STEP_ROUTES[0];
  const targetIndex = STEP_ROUTES.indexOf(path as (typeof STEP_ROUTES)[number]);
  const unlocked = onboarding.highestUnlockedStep();

  if (targetIndex < 0 || targetIndex <= unlocked) {
    return true;
  }

  const redirectSlug = STEP_ROUTES[Math.min(unlocked, STEP_ROUTES.length - 1)];
  return router.createUrlTree(['/onboarding', redirectSlug]);
};
